<style lang="less" scoped>
.detail-mes-div{
    line-height: 35px;
    padding: 0 10px;
    margin-bottom: 10px;
    font-size:14px;
    box-sizing: border-box;
}
.detail-title-div{
    width:150px;
    height: 35px;
    text-align: right;
    margin-right:50px;
}
.detail-pgh-div{
    background: #bb87f3;
    color: white;
    border-radius: 4px;
    padding: 0 16px;
    box-sizing: border-box;
}
.detail-btn{
    height:32px;
    margin-left: 45px;
}
.margin-rt-20{
    margin-right:20px;
}
.dialog-title-div{
    margin:15px 0px;
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="flex detail-form-parent-div">
                    <div class="flex-1">
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">订单编号：</div>
                            <div>{{detailForm.walletListNo}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">充电桩编号：</div>
                            <div>{{detailForm.pileCode}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">创建时间：</div>
                            <div>{{detailForm.transactionCreateTime}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">支付状态：</div>
                            <div>{{detailForm.transactionStatusName}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">支付套餐：</div>
                            <div class="detail-pgh-div">{{detailForm.packagName}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">套餐权益：</div>
                            <div class="detail-pgh-div">{{detailForm.packagEquity}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">权益使用年限：</div>
                            <div>{{detailForm.equityLength}}</div>
                        </div>
                    </div>
                    <div class="flex-1">
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">用户名：</div>
                            <div>{{detailForm.mobile}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">支付渠道：</div>
                            <div>{{detailForm.transactionChannelName}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">支付流水号：</div>
                            <div>{{detailForm.transactionId}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">支付金额：</div>
                            <div>{{detailForm.actInExpAmount}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div"></div>
                            <div></div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">权益内容包含：</div>
                            <div class="detail-pgh-div">{{detailForm.equityContent}}</div>
                        </div>
                        <div class="detail-mes-div flex align-items">
                            <div class="detail-title-div">权益使用起止时间：</div>
                            <div>{{detailForm.equityStartTime}} - {{detailForm.equityEndTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'支付订单详情',
                detailForm: {},
            }
        },
        methods: {
            //初始化表单内容 判断是否编辑模式
            init() {
                let _ = this;
                if(_.$store.state.editId){
                    this.editFlag = true;
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$H.post(_,_.$A.digitization.findListById,{id: _.$store.state.editId}).then(res => {
                     _.detailForm = res.data.data;
                });
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
